<form [formGroup]="formGroup" *ngIf="showDatenBeratungsprotokoll" appPropagateSubmit [parentFormGroupDirective]="parentFormGroupDirective">
  <div [ngClass]="{'mt-3': showHeadLine}">
    <h6 *ngIf="showHeadLine">Beratungsprotokoll</h6>
    <div class="row">
      <div class="col col-xs-12 col-sm-12">
        <div class="input_radio">
          <app-label [control]="beratungsprotokoll" for="beratungsprotokoll">Soll ein Beratungsprotokoll erstellt werden?</app-label>
          <mat-radio-group id="beratungsprotokoll" [formControl]="beratungsprotokoll">
            <mat-radio-button value="ja">Ja</mat-radio-button>
            <mat-radio-button value="nein">Nein</mat-radio-button>
          </mat-radio-group>
        </div>
      </div>
    </div>
  </div>
</form>
